import { z } from 'zod';

const isoDateTime = () => z.string().datetime({ offset: true });

export const billingAddressSchema = z.object({
  id: z.string().uuid(),
  clientId: z.string().uuid(),
  managerId: z.string().uuid().optional().nullable(),
  label: z.string().trim().min(1).optional().nullable(),
  addressLine1: z.string().trim().min(1).optional().nullable(),
  addressLine2: z.string().trim().min(1).optional().nullable(),
  city: z.string().trim().min(1).optional().nullable(),
  state: z.string().trim().min(1).optional().nullable(),
  zip: z.string().trim().min(1).optional().nullable(),
  isDefault: z.boolean(),
  createdAt: isoDateTime(),
  updatedAt: isoDateTime(),
});

export const billingAddressInputSchema = z.object({
  clientId: z.string().uuid(),
  managerId: z.string().uuid().nullable().optional().or(z.literal('').transform(() => undefined)),
  label: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
  addressLine1: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
  addressLine2: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
  city: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
  state: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
  zip: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
});

export const billingAddressUpdateSchema = z.object({
  managerId: z.string().uuid().nullable().optional(),
  label: z.string().trim().transform(v => v || null).optional().nullable(),
  addressLine1: z.string().trim().transform(v => v || null).optional().nullable(),
  addressLine2: z.string().trim().transform(v => v || null).optional().nullable(),
  city: z.string().trim().transform(v => v || null).optional().nullable(),
  state: z.string().trim().transform(v => v || null).optional().nullable(),
  zip: z.string().trim().transform(v => v || null).optional().nullable(),
});
